import { render } from "./SocialPost.vue?vue&type=template&id=122d03c8&scoped=true"
import script from "./SocialPost.vue?vue&type=script&lang=js"
export * from "./SocialPost.vue?vue&type=script&lang=js"

import "./SocialPost.vue?vue&type=style&index=0&id=122d03c8&lang=scss"
import "./SocialPost.vue?vue&type=style&index=1&id=122d03c8&lang=scss&scoped=true"
import "./SocialPost.vue?vue&type=style&index=2&id=122d03c8&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122d03c8"]])

export default __exports__